"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importDefault(require("react"));
var ProductVariations = function (_a) {
    var variations = _a.variations, onAdd = _a.onAdd, closeModal = _a.closeModal;
    var _b = react_1.default.useState(""), selectedVariationId = _b[0], setSelectedVariationId = _b[1];
    var _c = react_1.default.useState({}), selectedVariation = _c[0], setSelectedVariation = _c[1];
    var _d = react_1.default.useState(false), selectedOption = _d[0], setSelectedOption = _d[1];
    var handleRadioButtonChange = function (product) {
        var _a;
        var productCopy = __assign({}, product);
        productCopy.selected = true;
        var updatedProduct = __assign(__assign({}, productCopy), { selected_add_ons: [] });
        if (((_a = productCopy === null || productCopy === void 0 ? void 0 : productCopy.add_ons) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            productCopy.add_ons.forEach(function (addOn) {
                if (addOn.is_required) {
                    updatedProduct.selected_add_ons = __spreadArray(__spreadArray([], (updatedProduct.selected_add_ons || []), true), [addOn], false);
                }
            });
        }
        setSelectedVariation(updatedProduct);
    };
    var handleAddProducts = function () {
        onAdd(selectedVariation);
        setSelectedOption(false);
        closeModal(false);
    };
    var updateAddOns = function (product, add_on_product, checked) {
        var updatedProduct = __assign({}, product);
        updatedProduct.selected_add_ons = updatedProduct.selected_add_ons || [];
        if (checked) {
            updatedProduct.selected_add_ons = __spreadArray(__spreadArray([], updatedProduct.selected_add_ons, true), [add_on_product], false);
        }
        else {
            updatedProduct.selected_add_ons = updatedProduct.selected_add_ons.filter(function (x) { return x._id !== add_on_product._id; });
        }
        setSelectedVariation(updatedProduct);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [variations === null || variations === void 0 ? void 0 : variations.map(function (product) {
                var _a, _b;
                return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.RadioButtonsControl, { selectedValue: selectedVariationId, title: "", cols: "grid-cols-2", options: [{ label: product.title, value: product._id }], onChange: function (value) {
                                setSelectedOption(true);
                                setSelectedVariationId(value);
                                handleRadioButtonChange(product);
                            }, required: true, errorText: "", colors: {
                                error: {
                                    textColor: "text-red-800",
                                },
                            } }), selectedVariationId === product._id && ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "" }, { children: ((_a = product.add_ons) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                ((_b = product.add_ons) === null || _b === void 0 ? void 0 : _b.map(function (add_on_product) {
                                    var _a;
                                    return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.CheckboxControl, { disabledColor: "text-black", disabled: add_on_product.is_required, checkedColor: "text-black", uncheckedColor: "text-black", label: add_on_product.title, value: add_on_product.is_required ? true : !!((_a = selectedVariation.selected_add_ons) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x._id === add_on_product._id; })), onChange: function (checked) {
                                                    updateAddOns(selectedVariation, add_on_product, checked);
                                                } }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "mb-2" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.DividerControl, { addPadding: false }, add_on_product._id) }))] }), add_on_product._id));
                                })) })))] }, product._id));
            }), !selectedOption && (0, jsx_runtime_1.jsx)("small", __assign({ className: "text-red-500" }, { children: "* Selection Required" })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { enabled: selectedOption, label: "Accept", size: "small", backgroundColor: "bg-primary", textColor: "text-white", borderColor: "border-primary", onClick: handleAddProducts })] }));
};
exports.default = ProductVariations;
